import styles from './CardGrid.module.css';

interface CardGridProps {
  cards: React.ReactNode[];
  minColumnWidth?: number;
}

export default function CardGrid({ cards, minColumnWidth = 320 }: CardGridProps) {
  return (
    <div className={styles.grid} style={{ '--min-col': `${minColumnWidth}px` } as React.CSSProperties}>
      {cards.map((card, i) => (
        <div key={i} className={styles.item}>
          {card}
        </div>
      ))}
    </div>
  );
}
